module.exports = __webpack_public_path__ + "img/167.e1ef6458.jpg";